import { BehaviorSubject } from "rxjs";
import { RouterFilterReference } from "../../common/filters-router/filters-router.component";
import { FiltersTypeEnum } from 'world-archery-lib';
import * as i0 from "@angular/core";
export class TextFilterComponent extends RouterFilterReference {
    constructor() {
        super(FiltersTypeEnum.TextSearch);
        /**
         *
         * Default text value of filter
         * @memberof TextFilterComponent
         */
        this.defaultTextValue = "";
    }
    onChangeText(event) {
        this.text_subject.next(event);
        this.changeData.emit(event);
    }
}
TextFilterComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TextFilterComponent_Factory() { return new TextFilterComponent(); }, token: TextFilterComponent, providedIn: "root" });
